// Simplified API utility without authentication
import API_BASE_URL from '../config/api';

// Generic helper for your API - simplified without auth
export async function apiFetch(path, init = {}) {
  try {
    const headers = new Headers(init.headers || {});
    headers.set("Content-Type", headers.get("Content-Type") || "application/json");

    // Always use absolute Cloud Run URL to avoid Firebase Hosting interception
    const apiUrl = `${API_BASE_URL}/api/${path}`;

    const res = await fetch(apiUrl, { 
      ...init, 
      headers, 
      credentials: "omit" 
    });
    
    if (!res.ok) {
      console.error(`API Error ${path}: ${res.status} ${res.statusText}`);
      const errorText = await res.text();
      console.error(`API Error Details:`, errorText);
      throw new Error(`API request failed: ${res.status} ${res.statusText}`);
    }
    
    return res;
  } catch (error) {
    console.error('API request error:', error);
    throw error;
  }
}

// Convenience methods for common HTTP verbs
export const api = {
  get: (path) => apiFetch(path, { method: 'GET' }),
  post: (path, data) => apiFetch(path, { 
    method: 'POST', 
    body: JSON.stringify(data) 
  }),
  put: (path, data) => apiFetch(path, { 
    method: 'PUT', 
    body: JSON.stringify(data) 
  }),
  delete: (path) => apiFetch(path, { method: 'DELETE' }),
};

export default api;

// Convenience for image generation used by QuestionFlow
export async function fetchOptionImages({ projectData, question, options }) {
  return apiFetch('generate-option-images', {
    method: 'POST',
    body: JSON.stringify({ projectData, question, options })
  });
}

// Get cached images (with fuzzy matching fallback on backend)
export async function getInstantImages({ projectData, question, options }) {
  return apiFetch('get-instant-images', {
    method: 'POST',
    body: JSON.stringify({ projectData, question, options })
  });
}

// Generate instant Gemini image for a specific option
export async function generateInstantGeminiImage({ option_text, construction_type, question_context, save_to_cache = true }) {
  return apiFetch('instant-gemini-image', {
    method: 'POST',
    body: JSON.stringify({ 
      option_text,
      construction_type,
      question_context,
      save_to_cache
    })
  });
}
